import React from "react";

import ClientTabsLayout from "./ClientTabsLayout";
import InnerClientLayout from "./InnerClientLayout";

import { BreadcrumbType } from "@/types/breadcrumb-types";

interface AdminClientLayoutWrapperProps {
  children: React.ReactNode;
  breadcrumb?: BreadcrumbType;
  title?: string;
  clientId: string;
  excludeInnerLayout?: boolean;
}

const AdminClientLayoutWrapper: React.FC<AdminClientLayoutWrapperProps> = ({
  children,
  breadcrumb,
  title,
  clientId,
  excludeInnerLayout = false,
}) => {
  if (excludeInnerLayout) {
    return <>{children}</>;
  }

  const currentPage = breadcrumb?.currentPage || { label: title || "Page" };

  return (
    <ClientTabsLayout
      currentPage={currentPage}
      navigation={breadcrumb?.navigation}
      clientId={clientId}
      header={title}
    >
      <InnerClientLayout>{children}</InnerClientLayout>
    </ClientTabsLayout>
  );
};

export default AdminClientLayoutWrapper;